import { DEFAULT_LANG, SITE_URL, findSeoRoute, isSeoPathIndexable } from "@/config/seoRoutes";
import { getLocalizedPath, UNLOCALIZED_ROUTES } from "@/lib/i18nRoutes";
import { normalizeSeoPath } from "@/lib/seo/normalizeSeoPath";

const CANONICAL_ALIAS_PATHS = {
  "/learn": "/learning-center",
  "/marine-weather": "/weather",
  "/weather-forecast": "/weather",
  "/weather-forecast-for-sailing": "/weather",
  "/wind-forecast-for-boating": "/weather",
  "/sea-weather-forecast": "/weather",
  "/route-library": "/routes",
  "/chart-plotter": "/navigation",
  "/advanced-voyage-planner": "/navigation",
  "/cookie-policy": "/cookies",
};

function canonicalAliasPath(cleanPath) {
  if (CANONICAL_ALIAS_PATHS[cleanPath]) return CANONICAL_ALIAS_PATHS[cleanPath];
  const countryAlias = cleanPath.match(/^\/(marine-weather|sailing-weather|wind-forecast)\/([^/]+)$/);
  if (countryAlias) return `/weather/${countryAlias[2]}`;
  return null;
}

export function canonicalFor({ path = "/", lang = DEFAULT_LANG } = {}) {
  const rawPath = String(path || "/").split(/[?#]/)[0].replace(/\/+$/, "") || "/";
  const normalized = normalizeSeoPath(path);
  const cleanPath = normalized.path;
  const descriptor = findSeoRoute(cleanPath);
  if (!descriptor) return null;
  if (cleanPath === "/") {
    if (rawPath === "/") return SITE_URL;
    return lang === DEFAULT_LANG ? `${SITE_URL}/${DEFAULT_LANG}` : `${SITE_URL}/${lang}`;
  }

  if (!isSeoPathIndexable(cleanPath)) {
    const alias = canonicalAliasPath(cleanPath);
    return alias && alias !== cleanPath ? canonicalFor({ path: alias, lang }) : null;
  }

  const localized = descriptor.localizedIn?.includes(lang) ? lang : descriptor.localizedIn?.[0] || DEFAULT_LANG;
  if (descriptor.localizedIn?.length === 1 && descriptor.localizedIn[0] === DEFAULT_LANG && cleanPath !== "/" && normalized.routeKey && UNLOCALIZED_ROUTES[normalized.routeKey]) {
    return `${SITE_URL}${cleanPath}`;
  }

  const defaultLocalizedPath = normalized.routeKey ? getLocalizedPath(normalized.routeKey, DEFAULT_LANG) : null;
  const defaultCleanPath = defaultLocalizedPath
    ? (defaultLocalizedPath.replace(new RegExp(`^/${DEFAULT_LANG}(?=/|$)`), "") || "/").replace(/\/+$/, "") || "/"
    : null;
  const isTopLevelLocalizedRoute = normalized.routeKey && cleanPath === defaultCleanPath;

  return descriptor.kind !== "dynamic" && isTopLevelLocalizedRoute
    ? `${SITE_URL}${getLocalizedPath(normalized.routeKey, localized)}`
    : `${SITE_URL}/${localized}${cleanPath === "/" ? "/" : cleanPath}`;
}